export default __webpack_public_path__ + "static/media/bg5.d2eace76.png";